import { createSlice } from '@reduxjs/toolkit';
// Load initial state from storage/cookies for persistence
const savedLang = localStorage.getItem('language_code') || 'ar';
const savedDir = localStorage.getItem('direction') || 'rtl';

const initialState = {
  code: savedLang,
  offLine: false,
  directions: savedDir,
  screenwidth: window.innerWidth,
  drawerwidth: 350,
  currentpath: 'system/welcome',
  globalLoading: false,
  polygons: [],
  isopensidemenu: false,
}

export const settingsSlice = createSlice({
  name: 'settingsData',
  initialState: initialState,
  reducers: {
    setCode: (state, action) => {
      state.code = action.payload;
      localStorage.setItem('language_code', action.payload);
    },
    setDirections: (state, action) => {
      state.directions = action.payload;
      localStorage.setItem('direction', action.payload);
    },
    setOffLine: (state, action) => {
      state.offLine = action.payload
    },
    setscreenwidth: (state, action) => {
      state.screenwidth = action.payload
    },
    setDrawerWidth: (state, action) => {
      state.drawerwidth = action.payload
    },
    setCurrentPath: (state, action) => {
      state.currentpath = action.payload
    },
    setPolygonsRedux: (state, action) => {
      state.polygons = action.payload
    },
    setIsOpenSideMenu: (state, action) => {
      state.isopensidemenu = action.payload
    },
    setGlobalLoading: (state, action) => {
      state.globalLoading = action.payload
    }
  }
});

export const {
  setGlobalLoading,
  setOffLine,
  setscreenwidth,
  setCurrentPath,
  setPolygonsRedux,
  setIsOpenSideMenu,
  setCode,
  setDirections
} = settingsSlice.actions;



export default settingsSlice.reducer;
